import React from 'react'

import { SidebarHeader } from 'apps/aiAutomation/components/SidebarHeader/SidebarHeader'
import { useViewPayload } from 'apps/aiAutomation/hooks/layout'
import { SidebarViewType } from 'apps/aiAutomation/lib/sidebar'
import { KnowledgeEntryType, LinkEntry } from 'shared/api/requests/aiBusinessKnowledge/schemas'

import { LinkEntryEditor } from './components/LinkEntryEditor/LinkEntryEditor'
import { TextEntryEditor } from './components/TextEntryEditor/TextEntryEditor'
import { useEditor } from './hooks/useEditor'
import { getSidebarTitle } from './lib/getSidebarTitle'

import cm from './KnowledgeEditor.module.css'

export const KnowledgeEditor = () => {
  const newEntryType = useViewPayload(SidebarViewType.KNOWLEDGE_EDITOR)?.newEntryType

  const { isLoading, selectedEntry, save } = useEditor()

  const entryType = selectedEntry?.type || newEntryType || KnowledgeEntryType.LINK

  return (
    <section className={cm.knowledgeEditor}>
      <SidebarHeader
        title={getSidebarTitle({ entry: selectedEntry, newEntryType: entryType })}
        showCloseButton={false}
      />

      <div className={cm.knowledgeEditor__content}>
        {entryType === KnowledgeEntryType.TEXT &&
          (!selectedEntry || selectedEntry.type === KnowledgeEntryType.TEXT) && (
            <TextEntryEditor entry={selectedEntry} onSubmit={save} isLoading={isLoading} />
          )}

        {entryType === KnowledgeEntryType.LINK &&
          (!selectedEntry || selectedEntry.type === KnowledgeEntryType.LINK) && (
            <LinkEntryEditor
              entry={selectedEntry as LinkEntry | null}
              onSubmit={save}
              isLoading={isLoading}
            />
          )}
      </div>
    </section>
  )
}
